// extracted by mini-css-extract-plugin
export default {"container":"MealSearch_container__9mse8","form":"MealSearch_form__UlnwF","cards":"MealSearch_cards__oX4ah"};